<div class="flex" [class]="[colorCss]">
    <ng-container *ngIf="isSvg; else simpleIcon">
        <mat-icon svgIcon="{{ icon }}"></mat-icon>
    </ng-container>

    <ng-template #simpleIcon>
        <mat-icon>{{ icon }}</mat-icon>
    </ng-template>
</div>
